import React, { useEffect, useState } from 'react';
import { ToastContainer } from './ToastContainer';
import { ConfirmDialog, ConfirmDialogProps } from './ConfirmDialog';
import { toastManager } from '../../utils/toastManager';
import { ToastProps } from './Toast';

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastProps[]>([]);
  const [confirmDialog, setConfirmDialog] = useState<ConfirmDialogProps | null>(null);

  useEffect(() => {
    const unsubscribeToasts = toastManager.subscribeToasts(setToasts);
    const unsubscribeConfirm = toastManager.subscribeConfirm(setConfirmDialog);

    return () => {
      unsubscribeToasts();
      unsubscribeConfirm();
    };
  }, []);

  const handleToastClose = (id: string) => {
    toastManager.remove(id);
  };

  return (
    <>
      {children}
      <ToastContainer toasts={toasts} onClose={handleToastClose} />
      {confirmDialog && <ConfirmDialog {...confirmDialog} />}
    </>
  );
};
